import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ScrollService {
    /**
     * Scrolls the window to a specific vertical position
     * @param top - The Y position in pixels (default: 0)
     * @param behavior - 'auto' | 'smooth' (default: 'smooth')
     */
    scrollToPosition(
        top: number = 0,
        behavior: ScrollBehavior = 'smooth'
    ): void {
        window.scrollTo({
            top,
            behavior,
        });
    }

    /**
     * Scroll to a specific element by ID
     * @param elementId - The id of the element
     * @param behavior - 'auto' | 'smooth' (default: 'smooth')
     */
    scrollToElement(
        elementId: string,
        behavior: ScrollBehavior = 'smooth'
    ): void {
        const el = document.getElementById(elementId);
        if (el) {
            el.scrollIntoView({ behavior, block: 'start' });
        }
    }

    /**
     * Scroll by a certain number of pixels
     * @param offset - pixels to scroll down (+) or up (-)
     * @param behavior - 'auto' | 'smooth' (default: 'smooth')
     */
    scrollBy(offset: number, behavior: ScrollBehavior = 'smooth'): void {
        window.scrollBy({
            top: offset,
            behavior,
        });
    }
}
